"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var schema_1 = require("../data/schema");
var async_1 = require("../viewUtils/async");
var spinner_1 = require("../viewUtils/spinner");
var selectLinkType_1 = require("./selectLinkType");
var CLASS_NAME = 'ontodia-edit-form';
var EditElementTypeForm = /** @class */ (function (_super) {
    tslib_1.__extends(EditElementTypeForm, _super);
    function EditElementTypeForm(props) {
        var _this = _super.call(this, props) || this;
        _this.cancellation = new async_1.Cancellation();
        _this.onElementTypeChange = function (e) {
            var type = e.target.value;
            _this.setState(function (_a) {
                var elementData = _a.elementData, linkData = _a.linkData;
                return ({
                    elementData: tslib_1.__assign({}, elementData, { types: [type] }),
                    linkData: tslib_1.__assign({}, linkData, { linkTypeId: schema_1.PLACEHOLDER_LINK_TYPE }),
                });
            });
        };
        _this.renderPossibleElementType = function (elementType) {
            var view = _this.props.view;
            var type = view.model.createClass(elementType);
            var label = view.getElementTypeLabel(type).text;
            return React.createElement("option", { key: elementType, value: elementType }, label);
        };
        _this.state = { elementData: props.target, linkData: props.link };
        return _this;
    }
    EditElementTypeForm.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, metadataApi = _a.metadataApi, source = _a.source;
        if (!metadataApi) {
            return;
        }
        metadataApi.typesOfElementsDraggedFrom(source, this.cancellation.signal).then(function (elementTypes) {
            _this.setState({ elementTypes: elementTypes });
        });
    };
    EditElementTypeForm.prototype.renderElementType = function () {
        var _a = this.state, elementData = _a.elementData, elementTypes = _a.elementTypes;
        var value = elementData.types.length ? elementData.types[0] : '';
        return (React.createElement("label", null,
            "Element type",
            elementTypes ? (React.createElement("select", { className: 'ontodia-form-control', value: value, onChange: this.onElementTypeChange },
                React.createElement("option", { value: schema_1.PLACEHOLDER_ELEMENT_TYPE, disabled: true }, "Select element type"),
                elementTypes.map(this.renderPossibleElementType))) : React.createElement("div", null,
                React.createElement(spinner_1.HtmlSpinner, { width: 20, height: 20 }))));
    };
    EditElementTypeForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, view = _a.view, metadataApi = _a.metadataApi, source = _a.source;
        var _b = this.state, elementData = _b.elementData, linkData = _b.linkData;
        var isElementTypeSelected = elementData.types.indexOf(schema_1.PLACEHOLDER_ELEMENT_TYPE) < 0;
        var isLinkTypeSelected = linkData.linkTypeId !== schema_1.PLACEHOLDER_LINK_TYPE;
        return (React.createElement("div", { className: CLASS_NAME },
            React.createElement("div", { className: CLASS_NAME + "__body" },
                React.createElement("div", { className: CLASS_NAME + "__form-row" }, this.renderElementType()),
                React.createElement("div", { className: CLASS_NAME + "__form-row" },
                    React.createElement(selectLinkType_1.SelectLinkType, { view: view, metadataApi: metadataApi, link: linkData, source: source, target: elementData, onChange: function (data) { return _this.setState({ linkData: data }); }, disabled: !isElementTypeSelected }))),
            React.createElement("div", { className: CLASS_NAME + "__controls" },
                React.createElement("button", { className: "ontodia-btn ontodia-btn-success " + CLASS_NAME + "__apply-button", onClick: function () { return _this.props.onApply(elementData, linkData); }, disabled: !isElementTypeSelected || !isLinkTypeSelected }, "Apply"),
                React.createElement("button", { className: 'ontodia-btn ontodia-btn-danger', onClick: this.props.onCancel }, "Cancel"))));
    };
    return EditElementTypeForm;
}(React.Component));
exports.EditElementTypeForm = EditElementTypeForm;
